import React, { Component } from 'react';

export default class FooterView extends Component {
  render () {
    return (
      <footer id="footer" className={this.props.additionalClassName}>
        <div className="container">
          <div className="footer-frame">
            <div className="footer-logo">
              <a href="http://cloudinary.com">
                <img src="https://res.cloudinary.com/cloudinary/image/upload/fl_attachment/v1/logo/for_black_bg/cloudinary_logo_for_black_bg.svg" height="36" width="169" alt="cloudinary" />
              </a>
            </div>
            <div className="frame-left">
              <p>&copy; {new Date().getFullYear()} Cloudinary. All rights reserved</p>
              <ul className="footer-links">
                <li><a href="http://cloudinary.com/tos">Terms of use</a></li>
                <li><a href="http://cloudinary.com/privacy">Privacy Policy</a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}


/** WEBPACK FOOTER **
 ** ./src/js/components/FooterView.js
 **/